import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { DevBoxApi } from './devbox-api';
import { problemDetailsMessage } from './problem-details';

interface ICreateDevBoxClient {
  discoveryApi: DiscoveryApi;
  fetchApi: FetchApi;
}

// Placeholder: `/api/devbox` is not proxied yet. When the DevBox backend is ready, add it to
// nginx.conf and the frontend-app package.json dev proxy, like `/api/sonarqube`.
export const createDevBoxClient = ({
  discoveryApi,
  fetchApi,
}: ICreateDevBoxClient): DevBoxApi => {
  const get = async (path: string) => {
    const response = await fetchApi.fetch(
      `${await discoveryApi.getBaseUrl('devbox')}${path}`,
      { method: 'GET' },
    );
    if (!response.ok) {
      throw new Error(await problemDetailsMessage(response));
    }
    return response.json();
  };

  return {
    listServiceGroups: () => get('/v1/service-groups'),
  };
};
